import { useState, useEffect } from "react";
import LoadingSpinner from "./LoadingSpinner";
import { Button } from "../Universal/Button";
import { usePopup } from "../contexts/PopupContext";

const ScreenshotPopUp = () => {
  const {
    currentScreenshotForPopUp,
    setIsScreenshotPopUpOpen,
    setCurrentScreenshotForPopUp,
  } = usePopup();

  const [zoom, setZoom] = useState(1);

  const closePopUp = (e) => {
    if (e) {
      e.stopPropagation();
      e.nativeEvent?.stopImmediatePropagation?.();
      e.preventDefault();
    }
    setIsScreenshotPopUpOpen(false);
    setCurrentScreenshotForPopUp(null);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        closePopUp(e);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="fixed inset-0 flex flex-col h-screen bg-black/70 backdrop-blur-sm p-6 z-60"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="flex-1 w-full overflow-y-auto">
        <div className="w-full flex justify-center">
          {currentScreenshotForPopUp ? (
            <img
              src={currentScreenshotForPopUp}
              alt="Screenshot"
              className="h-auto max-w-none border border-velBlue/20"
              style={{ width: `${zoom * 100}%` }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            />
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>

      <div
        className="mt-6 flex items-center justify-center gap-4"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <input
          type="range"
          min="0.2"
          max="1"
          step="0.05"
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          className="w-48 h-1 bg-mutedText/30 appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:bg-velBlue [&::-webkit-slider-thumb]:rounded-full [&::-moz-range-thumb]:w-3 [&::-moz-range-thumb]:h-3 [&::-moz-range-thumb]:bg-velBlue [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:rounded-full"
        />
        <span className="text-mutedText text-sm font-light min-w-[3rem]">
          {Math.round(zoom * 100)}%
        </span>
        <Button onMouseDown={(e) => e.stopPropagation()} onClick={closePopUp}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default ScreenshotPopUp;
